export class AppealStatus {
  record_id: number;
  request_state_name___ru: string;
  request_state_name___kz: string;
  code_name: string;
}

export class AppealType {
  record_id: number;
  request_type_name___ru: string;
  request_type_name___kz: string;
}

export class Appeal {
  request_rid: number;
  request_number: number;
  request_date: Date;
  request_send_date: Date;
  request_type_rid: number;
  request_type_name___ru: string;
  request_type_name___kz: string;
  contract_rid: number;
  contract_number: string;
  request_state_rid: number;
  request_state_name___ru: string;
  request_state_name___kz: string;
  request_status_code_name: string;
  row_num: number;
  row_count: number;
  contact_person: string;
  email: string;
  contact_phone_number: string;
  request_description: string;
  response_description: string;
  reason_description: string;
}

export class AppealDTO {
  BIN: string;
  DateBegin: string;
  DateEnd: string;
  Status: number;
  iLimit: number;
  iOffset: number;
  TypeRid: number;
}
export class NewAppeal {
  request_id: number;
}

export class EditAppealDto {
  iRequestRid?: number;
  nvcRequestStateCodeName?: string;
  nvcContactPerson?: string;
  nvcEmail?: string;
  fContactPhoneNumber?: string;
  iRequestTypeRid?: number;
  iContractRid?: number;
  nvcRequestDescription?: string;
  nvcResponseDescription?: string;
}

export class EditAppealResult {
  result: boolean;
}

export class SaveAttachDTO {
  iRequestRid: number;
  IsAes: number;
  data: FormData;
}

export class SaveAttachResult {
  attach_rid: number;
}

export class AppealFile {
  request_attachment_rid: number;
  attach_file_name: string;
  file_size: string;
}

export class AppealFileDTO {
  request_attachment_rid: number;
}

export class FileData {
  attach_file: any;
}
